var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.336 5.572c0-2.48 1.955-4.094 4.164-4.094 2.21 0 4.165 1.615 4.165 4.094 0 .752-.303 1.625-.986 2.63-.683 1.004-1.722 2.106-3.137 3.307a.062.062 0 01-.039.012.061.061 0 01-.04-.012l-.351.422.355-.42c-1.42-1.201-2.46-2.305-3.144-3.309-.684-1.005-.987-1.878-.987-2.63z",
    stroke: "#000",
    strokeWidth: 1.1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.643,
    r: 1.593,
    stroke: "#000",
    strokeWidth: 1.1
  })));
}
export default SvgLocationIcon;